import { NgModule, Optional, SkipSelf } from '@angular/core';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { CalsoftSplashScreenModule } from './services/splash-screen/splash-screen.module';
import { CalsoftMediaWatcherModule } from './services/media-watcher/media-watcher.module';

@NgModule({
    imports  : [
        CalsoftMediaWatcherModule,
        CalsoftSplashScreenModule
    ],
    // providers: [
    //     {
    //         // Use the 'fill' appearance on form fields by default
    //         provide : MAT_FORM_FIELD_DEFAULT_OPTIONS,
    //         useValue: {
    //             appearance: 'outline'
    //         }
    //     }
    // ],
})
export class GlobalModule
{
    /**
     * Constructor
     *
     * @param parentModule
     */
    constructor(
        @Optional() @SkipSelf() parentModule?: GlobalModule
    )
    {
        if ( parentModule )
        {
            throw new Error('GlobalModule has already been loaded. Import this module in the AppModule only!');
        }
    }
}
